import React, { memo } from "react";

const Loader = () => {
  return (
    <div
      className="table-loading-container"
      style={{ position: "absolute", top: "50%" }}
    >
      <div className="table-loading" />
    </div>
  );
};

export default memo(Loader);
